var locale = {
  // Options
  items_per_page: '/ psl.',
  jump_to: 'Pereiti į',
  jump_to_confirm: 'patvirtinti',
  page: 'psl.',
  // Pagination
  prev_page: 'Atgal',
  next_page: 'Pirmyn',
  prev_5: 'Grįžti 5 psl.',
  next_5: 'Peršokti 5 psl.',
  prev_3: 'Grįžti 3 psl.',
  next_3: 'Peršokti 3 psl.',
  page_size: 'Puslapio dydis'
};
export default locale;